/**
 * Converts a date into YOM-friendly formatting.
 * @param {Date} date The date to format.
 * @returns {string} formatted date string.
 */
const formatDate = (date) => {
  const dateFormatter = Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hourCycle: "h12",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const formattedDate = dateFormatter.format(date);

  return formattedDate.replace(/,/g, "");
};

/**
 * Render function that formats dates for datatable columns.
 * @param {number|string|Date} input A UNIX timestamp in milliseconds or seconds, a date/datetime string, or a Date object
 * @returns {string} formatted date string
 */
export const renderDate = (input) => {
  if (!input) return null;

  let date;
  if (typeof input === "number" || /^\d+$/.test(input)) {
    const timestampStr = input.toString();

    if (timestampStr.length === 13) {
      date = new Date(Number(input));
    } else if (timestampStr.length === 10) {
      date = new Date(Number(input) * 1000);
    } else {
      return null;
    }
  } else if (typeof input === "string") {
    // Treat all string dates as UTC by appending 'Z' if no timezone info present
    let dateString = input.trim();

    // Only append 'Z' if there's no timezone information already
    if (
      !dateString.endsWith("Z") &&
      !dateString.includes("+") &&
      !dateString.includes("-", 10) && // Check after position 10 to avoid matching date separators
      !dateString.toLowerCase().includes("utc") &&
      !dateString.toLowerCase().includes("gmt")
    ) {
      dateString += "Z";
    }

    date = new Date(dateString);
  } else if (input instanceof Date) {
    date = input;
  } else {
    return null;
  }

  // Validate that the date is valid
  return isNaN(date.getTime()) ? null : formatDate(date);
};
